// extracted by mini-css-extract-plugin
export var quantityInput = "_jb-0";